import { CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-primary-menu-dropdown.css.lit';
import OutlineDropdown from '../../base/outline-dropdown/outline-dropdown';

/**
 * The IdbPrimaryMenuDropdown component
 * @element idb-primary-menu-dropdown
 * @extends OutlineDropdown
 *
 */
@customElement('idb-primary-menu-dropdown')
export class IdbPrimaryMenuDropdown extends OutlineDropdown {
  static styles: CSSResultGroup = [OutlineDropdown.styles, componentStyles];

  handleFocusChange() {
    setTimeout(() => {
      const activeElement =
        this.containingElement?.getRootNode() instanceof ShadowRoot
          ? document.activeElement?.shadowRoot?.activeElement
          : document.activeElement;
      if (
        !this.containingElement ||
        (activeElement && !this.containingElement.contains(activeElement))
      ) {
        this.hide();
      }
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'idb-primary-menu-dropdown': IdbPrimaryMenuDropdown;
  }
}
